import { useEffect, useState } from 'react';
import { EFirebaseContext, ENotice, ESnapshot, exists } from '../../types';
import { getAffidavitSettingsForNotice } from '../../pricing/affidavits';
import { AffidavitReconciliationSettings } from '../../types/organization';

export const useNoticeAffidavitSettings = (
  ctx: EFirebaseContext,
  notice: ESnapshot<ENotice> | undefined,
  options?: { skipNoticeLevelSettings: boolean }
) => {
  const [settings, setSettings] = useState<AffidavitReconciliationSettings>();
  const skipNoticeLevelSettings = !!options?.skipNoticeLevelSettings;

  useEffect(() => {
    if (!exists(notice)) {
      setSettings(undefined);
      return;
    }

    const check = async () => {
      const settings = await getAffidavitSettingsForNotice(
        ctx,
        notice,
        skipNoticeLevelSettings ? { skipNoticeLevelSettings: true } : undefined
      );
      setSettings(settings);
    };

    void check();
  }, [notice?.id, skipNoticeLevelSettings]);

  return settings;
};
